import React, { useMemo } from 'react';
import useWindowSize from './use-window-size';

export const useIsMobile = (breakpoint = 768) => {
  const windowSize = useWindowSize();
  const isMobile = useMemo(
    () => (windowSize.width <= breakpoint),
    [windowSize, breakpoint],
  );
  return isMobile;
};

export default useIsMobile;

export const withIsMobile = (Component) => (props) => {
  const isMobile = useIsMobile();
  return <Component {...props} isMobile={isMobile} />;
};

// import React, { useMemo } from 'react';
// import useWindowSize from './use-window-size';
//
// export const useIsMobile = (breakpoint = 768) => {
//   const isClient = typeof window === "object";
//   if (!isClient) {
//     return false;
//   }
//   let windowSize = null
//   if (window.api === undefined && window.api.windowSize === undefined) {
//     windowSize = window.api.windowSize;
//   } else {
//     windowSize = useWindowSize();
//   }
//
//   const getIsMobile = (windowSize, breakpoint) => (windowSize.width <= breakpoint);
//   const isMobile = getIsMobile(windowSize, breakpoint);
//
//   return isMobile;
// };
//
// export default useIsMobile;
//
// export const withIsMobile = (Component) => (props) => {
//   const isMobile = useIsMobile();
//   return <Component {...props} isMobile={isMobile} />;
// };
